export default __webpack_public_path__ + "static/about-baner-555a130434a122364356f1628558cd0d.png";